module.exports = __webpack_public_path__ + "img/line_haw.953ca37a.png";